export default {"src":"/_next/static/media/IBKR.650823cd.svg","height":18,"width":18};